<script setup>
import { computed } from 'vue'
import { useFutureStore } from '~/store/future'
import { div, percent } from '#imports'
import { getTimeLeft } from '~/utils/tools'
import { timestamp } from '@/apis/socket'

const { t } = useI18n()
const future = useFutureStore()
const getDirectClass = v => ({ 'text-buy': v > 0, 'text-sell': v < 0 })
const priceText = computed(() => fix(future.overview?.c, future.curInfo.ps))
const dl = computed(() => {
  const { r, rt, index, mark, ph, pl, tv, tt } = future.overview ?? {}
  const { ps, as } = future.curInfo
  return [
    { key: 'rate', dt: t('24H 涨跌'), dd: rt ?? '--', class: getDirectClass(r) },
    { key: 'index', dt: t('指数价'), dd: fix(index ?? '--', ps) },
    { key: 'mark', dt: t('标记价'), dd: fix(mark ?? '--', ps) },
    // { key: 'high', dt: t('24h高'), dd: fix(ph ?? '--', ps) },
    // { key: 'low', dt: t('24h低'), dd: fix(pl ?? '--', ps) },
    { key: 'amount', dt: `${t('24H 成交量')}(${future.base})`, dd: fix(tv ?? '--', as) },
    { key: 'value', dt: `${t('24H 成交额')}(${future.quote})`, dd: fix(tt ?? '--', ps) },
  ]
})
const fr = computed(() => future.overview?.fr)
const interval = div(86400, future.curInfo?.fundingInterval ?? 3).mul(1000)

const timeleft = computed(() => getTimeLeft(interval - timestamp.value % interval).join(':'))
</script>

<template>
  <div class="flex space-x-3 rtl:space-x-reverse">
    <dl class="flex flex-col justify-center space-y-1 text-xs leading-4 h-7">
      <dt class="text-base font-semibold">
        {{ priceText }}
      </dt>
    </dl>
    <dl v-for="i in dl" :key="i.key" class="flex flex-col justify-center space-y-1 text-xs leading-4 h-7">
      <dt class="text-xs text-textTertiary">
        {{ i.dt }}
      </dt>
      <dd :key="i.key" class="font-medium" :class="i.class">
        {{ i.dd }}
      </dd>
    </dl>
    <dl class="flex flex-col justify-center space-y-1 text-xs leading-4 h-7">
      <dt class="text-textTertiary">
        {{ `${$t('资金费率')}/${$t('结算时间')}` }}
      </dt>
      <dd class="font-medium">
        <ClientOnly fallback="--">
          <span :class="{ 'text-buy': fr > 0, 'text-sell': fr < 0 }">{{ fr ? percent(fr, 4) : '--' }}</span>
        </ClientOnly>
        /<span>
          <ClientOnly fallback="--">
            {{ timeleft }}
          </ClientOnly>
        </span>
      </dd>
    </dl>
  </div>
</template>
